import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import logo from './logo.png'
import { Link } from 'react-router-dom';
import './index.css'
import { HomeOutlined, ProjectOutlined, UserOutlined, MenuOutlined, CloseOutlined } from '@ant-design/icons';

const Navigation = () => {
    const [current, setCurrent] = useState('home');
    const [isScrolled, setIsScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const items = [
        {
            label: 'Home',
            key: 'home',
            icon: <HomeOutlined />,
            path: '/'
        },
        {
            label: 'Projects',
            key: 'projects',
            icon: <ProjectOutlined />,
            path: '/projects'
        },
        {
            label: 'About Us',
            key: 'aboutus',
            icon: <UserOutlined />,
            path: '/aboutus'
        },
    ];

    useEffect(() => {
        const path = location.pathname;
        if (path === '/' || path === '/home') {
            setCurrent('home');
        } else if (path === '/projects') {
            setCurrent('projects');
        } else if (path === '/aboutus') {
            setCurrent('aboutus');
        }
    }, [location]);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleClick = (key, path) => {
        setCurrent(key);
        setMobileMenuOpen(false);
        navigate(path);
    };

    return (
        <nav className={`navbar-main ${isScrolled ? 'scrolled' : ''}`}>
            <div className="navbar-container">
                <div className="navbar-logo">
                    <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                        <img src={logo} alt="Hong Yuan Construction" className="navbar-logo-img" />
                    </Link>
                </div>
                
                <div className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
                    {items.map((item) => (
                        <Link
                            key={item.key}
                            to={item.path}
                            className={`navbar-item ${current === item.key ? 'active' : ''}`}
                            onClick={() => handleClick(item.key, item.path)}
                        >
                            <span className="navbar-icon">{item.icon}</span>
                            <span className="navbar-label">{item.label}</span>
                        </Link>
                    ))}
                </div>

                <button 
                    className="navbar-toggle"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Toggle menu"
                >
                    {mobileMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
                </button>
            </div>
        </nav>
    );
}

export default Navigation;
